module.exports = __webpack_public_path__ + "img/icon-check-lg.f67c0689.svg";